export default {
  取消操作: '取消操作',
  删除选中: '删除选中',
  '你确定要删除所选记录吗？': '你确定要删除所选记录吗？',
  你当前选中: '你当前选中',
  '条记录，记录中的数据删除后将无法恢复！': '条记录，记录中的数据删除后将无法恢复！',
  批量删除: '批量删除',
  '该条记录存在数据，数据删除后将无法恢复，': '该条记录存在数据，数据删除后将无法恢复，',
  '确定删除?': '确定删除?',
  复制到下一行: '复制到下一行',
  复制到最后一行: '复制到最后一行',
  向上插入行: '向上插入行',
  向下插入行: '向下插入行'
};
